/* tslint:disable */
/* eslint-disable */
/**
 * Dashboard Service
 * This is the API documentation of the Dashboard service
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { DocumentGeneratorRepresentation } from './DocumentGeneratorRepresentation';
import {
    DocumentGeneratorRepresentationFromJSON,
    DocumentGeneratorRepresentationFromJSONTyped,
    DocumentGeneratorRepresentationToJSON,
    DocumentGeneratorRepresentationToJSONTyped,
} from './DocumentGeneratorRepresentation';

/**
 * 
 * @export
 * @interface DocumentRepresentation
 */
export interface DocumentRepresentation {
    /**
     * Identifier of the document.
     * @type {string}
     * @memberof DocumentRepresentation
     */
    key: string;
    /**
     * An arbitrary user defined name for the document.
     * @type {string}
     * @memberof DocumentRepresentation
     */
    name: string;
    /**
     * An arbitrary category for the document.
     * @type {string}
     * @memberof DocumentRepresentation
     */
    category: string;
    /**
     * Timestamp of the document upload. This is the timestamp when the document has been added.
     * @type {number}
     * @memberof DocumentRepresentation
     */
    uploadedAt: number;
    /**
     * Timestamp of the document creation. This is the timestamp when document has been created itself, not when it has been added.
     * @type {number}
     * @memberof DocumentRepresentation
     */
    createdAt: number;
    /**
     * The year for which the content of document is generated
     * @type {number}
     * @memberof DocumentRepresentation
     */
    contentYear?: number;
    /**
     * The month for which the content of document is generated
     * @type {number}
     * @memberof DocumentRepresentation
     */
    contentMonth?: number;
    /**
     * Key of the user that created the document
     * @type {string}
     * @memberof DocumentRepresentation
     */
    createdBy: string;
    /**
     * Optional portfolio key. If set, the document has a relation to the portfolio.
     * @type {string}
     * @memberof DocumentRepresentation
     */
    portfolioKey?: string;
    /**
     * Optional dashboard key. If set, the document has a relation to the dashboard.
     * @type {string}
     * @memberof DocumentRepresentation
     */
    dashboardKey?: string;
    /**
     * List of generators related to this document. Might be an empty list.
     * @type {Array<DocumentGeneratorRepresentation>}
     * @memberof DocumentRepresentation
     */
    generators: Array<DocumentGeneratorRepresentation>;
    /**
     * 
     * @type {boolean}
     * @memberof DocumentRepresentation
     */
    hasBeenShared: boolean;
    /**
     * 
     * @type {string}
     * @memberof DocumentRepresentation
     */
    state: string;
}

/**
 * Check if a given object implements the DocumentRepresentation interface.
 */
export function instanceOfDocumentRepresentation(value: object): value is DocumentRepresentation {
    if (!('key' in value) || value['key'] === undefined) return false;
    if (!('name' in value) || value['name'] === undefined) return false;
    if (!('category' in value) || value['category'] === undefined) return false;
    if (!('uploadedAt' in value) || value['uploadedAt'] === undefined) return false;
    if (!('createdAt' in value) || value['createdAt'] === undefined) return false;
    if (!('createdBy' in value) || value['createdBy'] === undefined) return false;
    if (!('generators' in value) || value['generators'] === undefined) return false;
    if (!('hasBeenShared' in value) || value['hasBeenShared'] === undefined) return false;
    if (!('state' in value) || value['state'] === undefined) return false;
    return true;
}

export function DocumentRepresentationFromJSON(json: any): DocumentRepresentation {
    return DocumentRepresentationFromJSONTyped(json, false);
}

export function DocumentRepresentationFromJSONTyped(json: any, ignoreDiscriminator: boolean): DocumentRepresentation {
    if (json == null) {
        return json;
    }
    return {
        
        'key': json['key'],
        'name': json['name'],
        'category': json['category'],
        'uploadedAt': json['uploadedAt'],
        'createdAt': json['createdAt'],
        'contentYear': json['contentYear'] == null ? undefined : json['contentYear'],
        'contentMonth': json['contentMonth'] == null ? undefined : json['contentMonth'],
        'createdBy': json['createdBy'],
        'portfolioKey': json['portfolioKey'] == null ? undefined : json['portfolioKey'],
        'dashboardKey': json['dashboardKey'] == null ? undefined : json['dashboardKey'],
        'generators': ((json['generators'] as Array<any>).map(DocumentGeneratorRepresentationFromJSON)),
        'hasBeenShared': json['hasBeenShared'],
        'state': json['state'],
    };
}

export function DocumentRepresentationToJSON(json: any): DocumentRepresentation {
    return DocumentRepresentationToJSONTyped(json, false);
}

export function DocumentRepresentationToJSONTyped(value?: DocumentRepresentation | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'key': value['key'],
        'name': value['name'],
        'category': value['category'],
        'uploadedAt': value['uploadedAt'],
        'createdAt': value['createdAt'],
        'contentYear': value['contentYear'],
        'contentMonth': value['contentMonth'],
        'createdBy': value['createdBy'],
        'portfolioKey': value['portfolioKey'],
        'dashboardKey': value['dashboardKey'],
        'generators': ((value['generators'] as Array<any>).map(DocumentGeneratorRepresentationToJSON)),
        'hasBeenShared': value['hasBeenShared'],
        'state': value['state'],
    };
}

